<div class="container-fluid tp-box" *ngIf="config?.arpreauth" [@flipState]="flip" @grow>
	<div class="row tp-box__side tp-box__back" *ngIf="flip === 'active' && preauthEnabled">
		<div class="card">
			<div class="card-header card-header-warning card-header-icon">
				<div class="card-icon pointer" (click)="toggleFlip(false)">
					<i class="material-icons">credit_card</i>
				</div>
				<h3 class="card-title">Pending Auths</h3>
			</div>
			<div class="card-body" *ngIf="items.length">
				<div
					*ngIf="voidFeedback"
					class="alert mb-3"
					[ngClass]="voidFeedback.type === 'success' ? 'alert-success' : 'alert-danger'"
					role="alert"
				>{{ voidFeedback.text }}</div>
				<p class="text-muted small mb-2">
					Card capture happens when you invoice the order; use this list to void holds or open the order.
				</p>
				<div class="pending-auths-toolbar mb-2">
					<button
						type="button"
						class="btn btn-success btn-sm"
						(click)="exportXlsx()"
						[disabled]="!displayData.length"
						title="Export XLSX"
					><i class="fa fa-file-excel-o"></i></button>
					<button
						type="button"
						class="btn btn-danger btn-sm ms-1"
						(click)="exportPdf()"
						[disabled]="!displayData.length || exporting"
						title="Export PDF"
					><i class="fa fa-file-pdf-o"></i></button>
					<select
						class="form-select form-select-sm pending-auths-expiry-select"
						[(ngModel)]="expiryFilter"
						title="Filter by expiry"
					>
						<option value="all">All holds</option>
						<option value="soon">Expiring within 2 days</option>
					</select>
					<input
						type="text"
						class="form-control form-control-sm pending-auths-search-input"
						placeholder="Filter table…"
						[(ngModel)]="searchTerm"
					/>
				</div>
				<div class="table-responsive">
					<table class="table table-sm table-hover table-striped pending-auths-table">
						<thead>
							<tr>
								<th scope="col" class="pending-auths-sortable" (click)="toggleSort('orderno')">
									<span class="pending-auths-th-label">Order</span>
									<i class="material-icons pending-auths-sort-icon">{{ sortIcon('orderno') }}</i>
								</th>
								<th scope="col" class="pending-auths-sortable" (click)="toggleSort('customer')">
									<span class="pending-auths-th-label">Customer</span>
									<i class="material-icons pending-auths-sort-icon">{{ sortIcon('customer') }}</i>
								</th>
								<th scope="col" class="text-end pending-auths-sortable" (click)="toggleSort('amount')">
									<span class="pending-auths-th-label">Amount</span>
									<i class="material-icons pending-auths-sort-icon">{{ sortIcon('amount') }}</i>
								</th>
								<th scope="col" class="pending-auths-sortable" (click)="toggleSort('created_iso')">
									<span class="pending-auths-th-label">Auth date</span>
									<i class="material-icons pending-auths-sort-icon">{{ sortIcon('created_iso') }}</i>
								</th>
								<th scope="col" class="pending-auths-sortable" (click)="toggleSort('expires')">
									<span class="pending-auths-th-label">Expires</span>
									<i class="material-icons pending-auths-sort-icon">{{ sortIcon('expires') }}</i>
								</th>
								<th scope="col" class="text-end pending-auths-actions-col">Void</th>
							</tr>
						</thead>
						<tbody>
							<tr *ngFor="let a of displayData; trackBy: trackByAuth" [class.table-warning]="a.expiring_soon">
								<td class="text-nowrap">
									<a
										*ngIf="a.orderno && a.debtorno"
										[routerLink]="['/customers/view', a.debtorno]"
										(click)="$event.stopPropagation()"
									>{{ a.orderno }}</a>
									<span *ngIf="a.orderno && !a.debtorno" class="text-muted">{{ a.orderno }}</span>
									<span *ngIf="!a.orderno" class="text-muted">—</span>
								</td>
								<td class="pending-auths-customer-cell">
									<a
										*ngIf="a.debtorno"
										[routerLink]="['/customers/view', a.debtorno]"
										(click)="$event.stopPropagation()"
									>{{ a.customer_name || a.debtorno }}</a>
									<span *ngIf="!a.debtorno">{{ a.customer_name || '—' }}</span>
								</td>
								<td class="text-end text-nowrap">{{ a.amount | number:'1.2-2' }}</td>
								<td class="text-nowrap">{{ a.created_iso }}</td>
								<td class="text-nowrap">
									<span *ngIf="a.days_until_expiry >= 0">{{ a.days_until_expiry }} day(s)</span>
									<span *ngIf="a.days_until_expiry < 0" class="text-danger">Expired</span>
									<span *ngIf="a.expiring_soon" class="badge badge-warning ml-1">Soon</span>
								</td>
								<td class="text-end text-nowrap">
									<button
										type="button"
										class="btn btn-sm btn-outline-danger"
										[disabled]="actionBusy[rowKey(a)]"
										(click)="voidAuth(a, $event)"
									>Void</button>
								</td>
							</tr>
							<tr *ngIf="displayData.length === 0 && items.length">
								<td colspan="6" class="text-center text-muted py-3">No rows match your filter.</td>
							</tr>
						</tbody>
					</table>
				</div>
				<div #print_table class="pending-auths-print-surface" aria-hidden="true">
					<table class="table table-sm table-bordered pending-auths-print-table">
						<thead>
							<tr>
								<th>Order</th>
								<th>Customer</th>
								<th class="text-end">Amount</th>
								<th>Auth date</th>
								<th>Expires</th>
								<th>Expiring soon</th>
							</tr>
						</thead>
						<tbody>
							<tr *ngFor="let a of displayData; trackBy: trackByAuth">
								<td>{{ a.orderno || '—' }}</td>
								<td>{{ a.customer_name || a.debtorno || '—' }}</td>
								<td class="text-end">{{ a.amount | number:'1.2-2' }}</td>
								<td>{{ a.created_iso }}</td>
								<td>
									<span *ngIf="a.days_until_expiry >= 0">{{ a.days_until_expiry }} day(s)</span>
									<span *ngIf="a.days_until_expiry < 0">Expired</span>
								</td>
								<td>{{ a.expiring_soon ? 'Yes' : 'No' }}</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
			<div class="card-body" *ngIf="!items.length">
				<p class="text-muted mb-0">No uncaptured authorizations.</p>
			</div>
		</div>
	</div>
	<div class="row tp-box__side tp-box__front" id="frontside" [ngClass]="flip === 'inactive' ? '' : 'd-none'">
		<div class="card card-stats">
			<div class="card-header card-header-warning card-header-icon">
				<div class="card-icon pointer" (click)="toggleFlip(true)">
					<i class="material-icons">credit_card</i>
				</div>
				<p class="card-category">Pending Auths</p>
			<h3 class="card-title">
				<span *ngIf="!isLoading && preauthEnabled">{{ items.length }}</span>
				<span *ngIf="!isLoading && !preauthEnabled" class="text-muted" style="font-size:.9rem">—</span>
				<span *ngIf="isLoading">
					<svg class="spinner" width="35px" height="35px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
						<circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
					</svg>
				</span>
			</h3>
			<small *ngIf="!isLoading && preauthEnabled && expiringSoonCount > 0">
				<p class="card-category text-info text-justify mt-3 mb-0 text-right pr-3">
					<span class="text-warning">{{ expiringSoonCount }} expiring within 2 days</span>
				</p>
			</small>
		</div>
		<div class="card-footer">
			<div class="stats" [class.pointer]="!isLoading && preauthEnabled">
				<a
					*ngIf="!isLoading && preauthEnabled"
					class="pointer"
					(click)="toggleFlip(true)"
					matTooltip="View"
					[matTooltipPosition]="'below'"
				>
					<i class="material-icons">visibility</i> View Now
				</a>
			</div>
		</div>
		</div>
	</div>
</div>
